module.exports = __webpack_public_path__ + "static/img/sc20.e8919c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc20.png
// module id = Wvh+
// module chunks = 25